import { useState } from 'react';
import { api } from '../lib/api.js';
import { useSite } from '../lib/site-context.jsx';
import { safeUrl, telHref } from '../lib/format.js';
import { Brand } from './Header.jsx';

function Newsletter() {
  const { t } = useSite();
  const [msg, setMsg] = useState({ text: '', tone: '' });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setBusy(true);
    setMsg({ text: '', tone: '' });
    try {
      await api('/api/newsletter', { method: 'POST', body: JSON.stringify({ email: form.elements.email.value }) });
      setMsg({ text: t('newsletter_done', 'Subscribed!'), tone: 'success' });
      form.reset();
    } catch (err) { setMsg({ text: err.message, tone: 'error' }); } finally { setBusy(false); }
  };
  return (
    <form className="newsletter-signup" id="kg-newsletter-form" onSubmit={submit}>
      <label htmlFor="kg-newsletter-email">{t('newsletter_label', 'Get new listing alerts')}</label>
      <div className="newsletter-row">
        <input type="email" id="kg-newsletter-email" name="email" placeholder="you@example.com" autoComplete="email" required />
        <button type="submit" className="btn btn-sm" disabled={busy}>{t('newsletter_button', 'Subscribe')}</button>
      </div>
      <div className={`form-msg ${msg.tone}`} id="kg-newsletter-msg" role="status">{msg.text}</div>
    </form>
  );
}

function SocialLinks({ raw }) {
  let links = [];
  try { links = typeof raw === 'string' ? JSON.parse(raw) : raw || []; } catch { links = []; }
  links = links.filter((l) => l && safeUrl(l.url) && l.platform);
  if (!links.length) return null;
  return (
    <div className="social-links" id="kg-social-links">
      {links.map((l) => <a key={`${l.platform}${l.url}`} href={safeUrl(l.url)} target="_blank" rel="noopener noreferrer" aria-label={l.platform}>{l.platform}</a>)}
    </div>
  );
}

export function Footer() {
  const { settings, year, footerLinks, nav, t } = useSite();
  const company = settings.company_name || 'KeysGrove';
  return (
    <footer className="site-footer">
      <div className="wrap footer-grid">
        <div className="footer-brand">
          <Brand settings={settings} />
          <p className="footer-note">&copy; {year} {company}. {settings.footer_legal_text || 'All projects listed subject to RERA registration.'}</p>
          {(settings.general_phone || settings.general_email) && (
            <p className="footer-contact">
              {settings.general_phone && <a href={telHref(settings.general_phone)}>{settings.general_phone}</a>}
              {settings.general_email && <a href={`mailto:${settings.general_email}`}>{settings.general_email}</a>}
            </p>
          )}
          <Newsletter />
        </div>
        <nav className="footer-nav" aria-label="Footer">
          <a href="/">{t('nav_home', 'Home')}</a>
          <a href="/projects">{t('nav_projects', 'Projects')}</a>
          <a href="/compare">{t('nav_compare', 'Compare')}</a>
          {nav?.blog && <a href="/blog">{t('nav_blog', 'Blog')}</a>}
          <a href="/contact">{t('nav_contact', 'Contact')}</a>
          <a href="/privacy">{t('nav_privacy', 'Privacy')}</a>
          <a href="/terms">{t('nav_terms', 'Terms')}</a>
          <a href="/admin" rel="nofollow">{t('nav_admin', 'Admin')}</a>
        </nav>
      </div>
      <div className="wrap">
        <SocialLinks raw={settings.social_links} />
        {footerLinks?.length > 0 && (
          <div className="seo-footer-links">
            <span>Popular searches</span>
            {footerLinks.map((l) => <a key={l.path || l.slug} href={l.path || `/properties/${l.slug}`}>{l.phrase}</a>)}
          </div>
        )}
      </div>
    </footer>
  );
}
